import {
  Building2,
  FileCheck2,
  Car,
  LandPlot,
  TreePine,
  Hammer,
  Layers,
  Home,
  Dumbbell,
  Gamepad2,
  Film,
  Coffee,
  Waves,
  Activity,
  Map,
  Leaf
} from "lucide-react";


import p11 from "../assets/images/projects/EmbassyAstraupcoming.jpeg";
import p12 from "../assets/images/projects/project12.jpg";

import p13 from "../assets/images/projects/Project13.jpg";
import p14 from "../assets/images/projects/Aminites1.jpg";
import p15 from "../assets/images/projects/Aminites2.jpg";
//sattava
import s1 from "../assets/images/projects/sattva1.jpeg";
import s2 from "../assets/images/projects/sattva2.jpeg";
//sattava aminitis

import s3 from "../assets/images/projects/Sattva_Gym_Hires.jpg";
import s4 from "../assets/images/projects/Sattva_Indoor_Games_Hires.jpg";
import s5 from "../assets/images/projects/Pool Cam.jpg";
import s6 from "../assets/images/projects/MultiPurpose_Hall_Hires.jpg";
//birla
import b1 from "../assets/images/projects/Birlathirmaya1.jpeg";


import purvanakarUpcmoing1 from "../assets/images/projects/PurvanakarUpcoming1.jpeg";

import Sublime from "../assets/images/projects/sublime2.jpeg";
import ShobaUpcoming1 from "../assets/images/projects/ShobaupComing1.jpeg";

import Brochure1 from "../assets/Brochure/EmbassyGreenshoreBrochure.pdf";

export const ICONS = {
  Building2,
  FileCheck2,
  Car,
  LandPlot,
  TreePine,
  Hammer,
  Layers,
  Home,
  Dumbbell,
  Gamepad2,
  Film,
  Coffee,
  Waves,
  Activity,
  Map,
  Leaf
};

export const projects = [
  //jayram
  {
    slug: "Embassy-Astra-18mk",
    title: "Embassy Astra",
    location: "Hebbal",
    image: p11,
    projects: "Embassy Astra",
    topTag: "Possession: December 30, 2031",
    imageTag: "Premium",
    status: "Featured",
    statusType: "featured",
    img: [p12, p13, p14, p15],
    Brochure: [Brochure1],
    overview: {
      heading: "About the Project",
      paragraphs: [
        "Embassy Astra is an upcoming ultra-luxury residential apartment project by the reputed Embassy Group, located at Hebbal, North Bangalore on Bellary Road.",

        "Spread across around 10.5 acres, the development features four high-rise towers with spacious 3 and 4 BHK homes designed for premium urban living, offering large layouts, excellent ventilation, and up to 70% landscaped open spaces.",

        "The project enjoys prime connectivity to Manyata Tech Park, Outer Ring Road, reputed schools, hospitals, and Kempegowda International Airport, making it ideal for both end-users and investors. ",
        " Embassy Astra is planned with world-class lifestyle amenities including a grand clubhouse, swimming pool, gymnasium, sports courts, landscaped gardens, children’s play zones, and 24/7 security, delivering a modern gated-community lifestyle in one of Bangalore’s fastest-growing residential corridors."
      ]
    },

    // 🔹 PROJECT DESCRIPTION SECTION
    description: {
      intro:
        "Embassy Astra is an upcoming ultra-luxury residential apartment project by the reputed Embassy Group, located at Hebbal, North Bangalore on Bellary Road.",

      highlights: [
        "2B + G + 18 Floors",
        "8 Towers across 14 Acres",
        "Spacious 2, 3 & 4 BHK Residences"
      ],

      configurations: [
        "2 BHK – 1200 sft",
        "3 BHK – 1750–1850 sft",
        "4 BHK – 2200–2600 sft"
      ],

      price: "1.35 Cr onwards"
    },
    summary: [
      {
        label: "Project Name",
        value: "Embassy Green Shore",
        icon: "Building2"
      },
      {
        label: "RERA No",
        value: "PRM/KA/RERA/1250/303/PR/201125/00826",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Embassy Springs", icon: "Home" },
      { label: "Structure Type", value: "2B + G + 18 Floors", icon: "Car" },
      { label: "Total Land Area", value: "14 Acres", icon: "LandPlot" },
      { label: "Open Space Area", value: "75%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Floors", value: "18", icon: "Layers" },
      { label: "Units", value: "878", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & multipurpose hall"
          },
          {
            icon: "Film",
            title: "Mini Theatre",
            desc: "Private cinema experience"
          },
          { icon: "Coffee", title: "Terrace Café", desc: "Casual dining space" }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          { icon: "Waves", title: "Swimming Pool", desc: "Adult & kids pool" },
          {
            icon: "Activity",
            title: "Sports Courts",
            desc: "Badminton & basketball"
          },
          { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "Landscaped Gardens",
            desc: "Open green zones"
          }
        ]
      }
    ]
  },
  //Sattva
  
  //Birla
  {
    slug: "Sublime-by-Assetz",
    title: "Sublime by Assetz ",
    location: "Hoskote , Madras Road East Bengalore",
    image: Sublime,
    topTag: "Handover: 2029 Onwards",
    imageTag: "Premium",
    status: "Ready",
    statusType: "ready",
    img: [p12, p13, p14, p15],
    Brochure: [Brochure1],
    overview: {
      heading: "About the Project",
      paragraphs: [
        " Sublime by Assetz is a premium residential development designed for those who seek sophistication, comfort, and a refined urban lifestyle. Thoughtfully crafted with contemporary architecture and intelligent space planning, this landmark project brings together modern aesthetics and functional design to create homes that truly live up to their name—sublime. Every residence is designed to maximize natural light, ventilation, and privacy, offering a serene retreat from the fast-paced city life while keeping you well connected to key destinations.",

        "Set in a prime location, Sublime by Assetz offers seamless access to major IT hubs, business districts, reputed schools, healthcare centers, and entertainment zones. The project is enriched with world-class amenities including a fully equipped clubhouse, landscaped gardens, swimming pool, fitness center, jogging tracks, children’s play areas, and dedicated leisure spaces that encourage community living and holistic well-being",

        "Sustainable features and eco-conscious planning further enhance the living experience, making it an ideal choice for modern families."
      ]
    },

    // 🔹 PROJECT DESCRIPTION SECTION
    description: {
      intro:
        "Birla Trimaya Phase 2 is a premium integrated township by Birla Estates located in the fast-growing Devanahalli–Shettigere corridor of North Bangalore",

      highlights: [
        "B + G + 12 Floors",
        "8 Towers across 7.34 Acres",
        "Spacious 2, 3 & 4 BHK Residences"
      ],

      configurations: [
        "1 BHK – 551 sft",
        "2 BHK – 827-870 sft",
        "3 BHK – 1029-1100 sft",
        "3.5 BHK – 1178-1213 sft",
        "4 BHK – 2175-3119 sft"
      ],

      price: "1.3 Cr onwards"
    },
    summary: [
      { label: "Project Name", value: "Birla ", icon: "Building2" },
      {
        label: "RERA No",
        value: "PRM/KA/RERA/1250/303/PR/040924/006988",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Birla Estates", icon: "Home" },
      {
        label: "Structure Type",
        value: "RCC Framed  Structure 12-13 Floors",
        icon: "Car"
      },
      { label: "Total Land Area", value: "7.34 Acres", icon: "LandPlot" },
      { label: "Open Space Area", value: "75%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Floors", value: "13", icon: "Layers" },
      { label: "Units", value: "473", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & multipurpose hall"
          },
          // { icon: "Film", title: "Mini Theatre", desc: "Private cinema experience" },
          { icon: "Coffee", title: "Terrace Café", desc: "Casual dining space" }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          { icon: "Waves", title: "Swimming Pool", desc: "Adult & kids pool" },
          {
            icon: "Activity",
            title: "Sports Courts",
            desc: "Tennis Court & basketball"
          },
          // { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "Landscaped Gardens",
            desc: "Open green zones"
          }
        ]
      }
    ]
  },

{
    slug: "Purva-Silversky",
    title: "Purva Silversky",
    location: "Hebbagodi",
    image: purvanakarUpcmoing1,
    topTag: "Possession: September, 2026",
    imageTag: "Premium",
    status: "Featured",
    statusType: "offplan",
    img: [s1, s3, s4, s5, s6],
    Brochure: [Brochure1],
    overview: {
      heading: "About the Project",
      paragraphs: [
        "Purva Silversky is a luxury residential development in Hebbagodi, Electronic City, offering thoughtfully designed 3 and 4 Bed apartments for those who value space, calm, and contemporary living. Envisioned by Hafeez Contractor and spread across 6.99 acres, the development is planned to complement the rhythm of modern life, allowing work and home to coexist with ease.",

        "With just 356 exclusive apartments, Purva Silversky reflects the advantage of low-density living in Bengaluru’s technology corridor. Landscaped green spaces, wellness-inspired amenities, and elegant architectural detailing create an address that feels open, composed, and quietly restorative.",

        "Here, balance is experienced through everyday living in unhurried moments, generous spaces, and time that feels naturally your own. Here, balance isn’t an idea. It’s a way of living."
      ]
    },

    // 🔹 PROJECT DESCRIPTION SECTION
    description: {
      intro:
        "Salarpuria Sattva La Vita features the very best in Sattva Group’s luxury segment.",

      highlights: ["B + G + 2Floors", "4 BHK Row Houses"],

      configurations: ["4 BHK Row Houses"],

      price: "5.53 Cr onwards"
    },
    summary: [
      { label: "Project Name", value: "Sattva La Vita", icon: "Building2" },
      {
        label: "RERA No",
        value: "PRM/KA/RERA/1251/446/PR/ 041223/006446",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Salarpuria Sattva", icon: "Home" },
      { label: "Structure Type", value: "B + G + 2Floors", icon: "Car" },
      { label: "Total Land Area", value: "3Acres", icon: "LandPlot" },
      { label: "Open Space Area", value: "53.21%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Floors", value: "2", icon: "Layers" },
      { label: "Units", value: "63", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & multipurpose hall"
          },
          {
            icon: "Film",
            title: "Private Theatre",
            desc: "Private cinema experience"
          },
          { icon: "Coffee", title: "Tabel Tennies", desc: "Tennies Tennies" }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          { icon: "Waves", title: "Swimming Pool", desc: "Adult & kids pool" },
          {
            icon: "Activity",
            title: "Sports Courts",
            desc: "Tabel Tennis & basketball & Cricket Pitch"
          },
          { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "Landscaped Gardens",
            desc: "Open green zones"
          }
        ]
      }
    ]
  },

   {
    slug: "Sobha-World-City",
    title: "Sobha World City  ",
    location: "Hoskote , East Bengalore",
    image: ShobaUpcoming1,    
    topTag: "Handover: 2029 Onwards",
    imageTag: "Premium",
    status: "Ready",
    statusType: "ready",
    img: [p12, p13, p14, p15],
    Brochure: [Brochure1],
    overview: {
      heading: "About the Project",
      paragraphs: [
        " Sobha World City is a great place to live because it offers beautiful design, large rooms, and a location that is easy to access. This project by Sobha Developers, spread over 48 acres of prime land, transforms the way people live in today’s modern city lifestyle.",

        "The development features 18 blocks with a total of 5,400 flats and thoughtfully planned layouts that include spacious 2, 3, and 4 BHK homes. Each home is built with the uncompromised Sobha quality, exceptional attention to detail, and precision engineering the brand is known for.",

        "With scenic views, wide-open spaces, and a variety of premium amenities, Sobha World City blends daily convenience with a truly luxurious way of living—offering a perfect balance of comfort and elegance."
      ]
    },

    // 🔹 PROJECT DESCRIPTION SECTION
    description: {
      intro:
        "Birla Trimaya Phase 2 is a premium integrated township by Birla Estates located in the fast-growing Devanahalli–Shettigere corridor of North Bangalore",

      highlights: [
        "B + G + 12 Floors",
        "8 Towers across 7.34 Acres",
        "Spacious 2, 3 & 4 BHK Residences"
      ],

      configurations: [
        "1 BHK – 551 sft",
        "2 BHK – 827-870 sft",
        "3 BHK – 1029-1100 sft",
        "3.5 BHK – 1178-1213 sft",
        "4 BHK – 2175-3119 sft"
      ],

      price: "1.3 Cr onwards"
    },
    summary: [
      { label: "Project Name", value: "Birla ", icon: "Building2" },
      {
        label: "RERA No",
        value: "PRM/KA/RERA/1250/303/PR/040924/006988",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Birla Estates", icon: "Home" },
      {
        label: "Structure Type",
        value: "RCC Framed  Structure 12-13 Floors",
        icon: "Car"
      },
      { label: "Total Land Area", value: "7.34 Acres", icon: "LandPlot" },
      { label: "Open Space Area", value: "75%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Floors", value: "13", icon: "Layers" },
      { label: "Units", value: "473", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & multipurpose hall"
          },
          // { icon: "Film", title: "Mini Theatre", desc: "Private cinema experience" },
          { icon: "Coffee", title: "Terrace Café", desc: "Casual dining space" }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          { icon: "Waves", title: "Swimming Pool", desc: "Adult & kids pool" },
          {
            icon: "Activity",
            title: "Sports Courts",
            desc: "Tennis Court & basketball"
          },
          // { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "Landscaped Gardens",
            desc: "Open green zones"
          }
        ]
      }
    ]
  },
 
];
